<template>
  <div class="sp_allCase">
    <div v-if="showContent"
         class="content">
      <heade-title :title="title"></heade-title>

      <div class="sp_content">
        <!-- 搜索区域 -->
        <div class="sp_search">
          <el-row type="flex"
                  :gutter="10">
            <el-col>
              <el-button type="primary"
                         size="small"
                          style="background-color: #a0cfff;border-color: #a0cfff;"
                         @click="showCreateCase">
                <svg-icon icon-class="add"></svg-icon>&nbsp;&nbsp;Create
              </el-button>
            </el-col>
            <el-col>
              <el-button plain
                         size="small"
                         style="margin-right:16px"
                         @click="handleRefresh">
                <svg-icon icon-class="refresh"></svg-icon>&nbsp;&nbsp;Refresh
              </el-button>
            </el-col>
          </el-row>
          <el-row type="flex"
                  :gutter="10">
            <el-col>
              <el-date-picker v-model="submitDate"
                              type="daterange"
                              range-separator="-"
                              format="yyyy-MM-dd"
                              value-format="yyyy-MM-dd"
                              start-placeholder="Start Time"
                              end-placeholder="End Time"
                              size="small"
                              @change="conditionSearch"></el-date-picker>
            </el-col>
            <el-col :span="16">
              <el-select clearable
                         v-model="filter.status"
                         placeholder="Status"
                         size="small"
                         @change="conditionSearch">
                <el-option label="Closed"
                           :value="0"></el-option>
                <el-option label="Open"
                           :value="1"></el-option>
              </el-select>
            </el-col>
            <el-col :span="16">
              <el-select v-model="filter.product"
                         placeholder="Product"
                         size="small"
                         multiple
                         collapse-tags
                         @change="conditionSearch">
                <el-option v-for="val in productList"
                           :key="val.id"
                           :label="val.name"
                           :value="val.id"></el-option>
              </el-select>
            </el-col>
            <el-col>
              <el-input type="text"
                        v-model="filter.keyword"
                        size="small"
                        placeholder="Title/ Descritption/Case No/Gateway ID/SN."
                        @keyup.enter.native="conditionSearch">
                <i class="el-input__icon el-icon-search"
                   slot="suffix"
                   @click="conditionSearch"></i>
              </el-input>
            </el-col>
            <el-col :span="2">
              <el-button class="button_reset"
                         size="small"
                         @click="handleReset">
                <svg-icon icon-class="reset"></svg-icon>
              </el-button>
            </el-col>
          </el-row>
        </div>
        <!-- 表格区域 -->
        <el-row class="case-table-content"
                style="padding:0 16px 16px; background: #fff;"
                v-loading="tableLoading">
          <el-col class="case-table"
                  :span="24">
            <el-table class="table"
                      :data="tableData"
                      border
                      ref="myTable"
                      :header-cell-style="setHeadeStyle"
                      size="dedium">
              <el-table-column label="#"
                               align="center"
                               type="index"
                               width="55"></el-table-column>
              <el-table-column label="Case ID"
                               width="120"
                               show-overflow-tooltip
                               :render-header="renderHeader">
                <template slot-scope="scope">
                  <span @click="goToDetailPage(scope.row)"
                        style="color:#007AFF; cursor: pointer;">{{scope.row.caseNo}}</span>
                </template>
              </el-table-column>
              <el-table-column label="Company Name"
                               prop="customer"
                               show-overflow-tooltip
                               :render-header="renderHeader"
                               width="170"></el-table-column>
              <el-table-column label="Product"
                               width="80"
                               show-overflow-tooltip
                               :render-header="renderHeader">
                <template slot-scope="scope">
                  <span>{{prodectDic[scope.row.product]}}</span>
                </template>
              </el-table-column>
              <el-table-column label="Title"
                               prop="issueTitle"
                               show-overflow-tooltip
                               :render-header="renderHeader"></el-table-column>
              <el-table-column label="Description"
                               prop="issueDescriptions">
                <template slot-scope="scope">
                  <el-tooltip class="item"
                              effect="dark"
                              placement="top">
                    <div v-html="ToBreak(scope.row.issueDescriptions)"
                         slot="content"></div>
                    <div class="oneLine">{{scope.row.issueDescriptions}}</div>
                  </el-tooltip>
                </template>
              </el-table-column>
              <el-table-column label="Status"
                               width="100"
                               show-overflow-tooltip
                               :render-header="renderHeader">
                <template slot-scope="scope">
                  <span :style="statusStyle[scope.row.status]">{{scope.row.status==0?'Closed':'Open'}}</span>
                </template>
              </el-table-column>
              <el-table-column label="Issue Severity"
                               width="120"
                               :show-overflow-tooltip="true"
                               :render-header="renderHeader">
                <template slot-scope="scope">
                  <span :style="impactLevelDic[scope.row.impactLevel].color">
                    {{impactLevelDic[scope.row.impactLevel].name}}
                  </span>
                </template>
              </el-table-column>
              <el-table-column label="Update Date"
                               width="160"
                               prop="modifiedDate"
                               show-overflow-tooltip
                               :render-header="renderHeader">
                <template slot-scope="scope">
                  <span>{{moment(scope.row.modifiedDate).format('YYYY-MM-DD HH:mm:ss')}}</span>
                </template>
              </el-table-column>
              <el-table-column label="Submit by"
                               prop="createdByName"
                               show-overflow-tooltip
                               :render-header="renderHeader"></el-table-column>
              <el-table-column label="Contact Person"
                               prop="contact"
                               show-overflow-tooltip
                               :render-header="renderHeader"></el-table-column>
              <el-table-column label="Evaluation"
                               fixed="right"
                               width="120"
                               align="left">
                <template slot-scope="scope">
                  <el-button type="text"
                             size="small"
                             v-if="scope.row.status==0"
                             @click="handleRete(scope.row)">{{scope.row.isRate==0?'Rate':'Rated'}}</el-button>
                </template>
              </el-table-column>
            </el-table>
          </el-col>

          <el-col class="pagination"
                  :span="24"
                  style="text-align:right;">
            <el-pagination @size-change="handleSizeChange"
                           @current-change="handleCurrentChange"
                           :page-sizes="pageSizes"
                           :page-size="filter.pageSize"
                           :current-page="filter.pageNumber"
                           :disabled="total < 10"
                           layout="total, sizes, prev, pager, next, jumper"
                           :total="total">
            </el-pagination>
          </el-col>
        </el-row>
      </div>
    </div>
    <!-- 组件区域 -->
    <create-case class="sp_createCase"
                 :createCaseMsg="createCaseMsg"
                 @createCaseChildMsg="createCaseChildMsg"
                 v-if="createCaseMsg.show"></create-case>
    <case-detail class="sp_caseDetail"
                  :caseDetailMsg="caseDetailMsg"
                  @caseDetailChildMsg="caseDetailChildMsg"
                  v-if="caseDetailMsg.show"></case-detail>
  </div>
</template>

<script>
import headeTitle from '../../components/headeTitle.vue'
import { tableMixis } from "@/mixins/tableMixis.js"
import CreateCase from './createCase.vue'
import { getAreaCode } from "@/api/loginApi.js"
import { getProductApi, getTimeZoneApi, getCaseListApi } from "@/api/case.js"
import CaseDetail from './caseDetail.vue'
import moment from 'moment'
export default {
  components: { headeTitle, CreateCase, CaseDetail },
  mixins: [tableMixis],
  name: 'allCase',
  data () {
    return {
      title: 'All Cases',
      showContent: true,
      submitDate: [],
      tableData: [],
      filter: {
        beginTime: "",
        endTime: '',
        status: '',
        product: [],
        keyword: '',
        pageSize: 10,
        pageNumber: 1,
      },
      defualtFilter: {},
      createCaseMsg: {
        row: {},
        show: false,
      },
      caseDetailMsg: {
        row: {},
        show: false,
        isRate: false,
      },
      productList: [],
      tableLoading: false,
      statusStyle: {
        0: {
          padding: '0px 10px',
          borderRadius: '45px',
          background: '#79828C',
          display: 'inline-block',
          height: '22px',
          'line-height': '22px',
          color: '#fff',
        },
        1: {
          padding: '0px 10px',
          borderRadius: '45px',
          background: '#32C093',
          display: 'inline-block',
          height: '22px',
          'line-height': '22px',
          color: '#fff',
        }
      },
      rateStyle: {
        0: {
          padding: '5px 15px',
          borderRadius: '4px',
          background: '#fff',
          display: 'inline-block',
          height: '22px',
          'line-height': '22px',
          color: '#007AFF',
          border: '1px solid #007AFF',
          cursor: 'pointer'

        },
        1: {
          padding: '5px 10px',
          borderRadius: '4px',
          background: '#fff',
          height: '22px',
          'line-height': '22px',
          display: 'inline-block',
          color: '#2b2b2b',
          border: "1px solid #2b2b2b",
          cursor: 'pointer'
        }
      },
      impactLevelDic: {
        4: {
          name: "Low", color: {
            display: 'inline-block',
            color: "#2684FF", background: '#EBF3FF', padding: '0 8px', height: '22px',
            'line-height': '22px',
          }
        },
        3: {
          name: "Medium", color: {
            display: 'inline-block',
            color: "#FF9500", background: '#FCF0E3', padding: '0 8px', height: '22px',
            'line-height': '22px',
          }
        },
        2: {
          name: "High", color: {
            display: 'inline-block',
            color: "#D94B4B", background: '#FCE8E8', padding: '0 8px', height: '22px',
            'line-height': '22px',
          }
        },
        1: {
          name: "Critical", color: {
            display: 'inline-block',
            color: "#900E0E", background: '#F3E6E6', padding: '0 8px', height: '22px',
            'line-height': '22px',
          }
        },
      },
    }
  },

  methods: {
    ToBreak (val) {
      return val.replace(/\n/g, '<br/>') //这里的aaa指的是上文中提到的分隔符
    },
    //表头样式
    renderHeader (h, data) {
      return h("span", [
        h(
          "el-tooltip",
          {
            attrs: {
              class: "item",
              effect: "dark",
              content: data.column.label,
              placement: "top",
              color: '#ffffff'
            },
          },
          [h("span", data.column.label)]
        ),
      ]);
    },
    //获取工单列表
    handleSearch (data) {
      this.tableLoading = true;
      let params = JSON.parse(JSON.stringify(data))
      params.channelId = this.$store.getters.userInfo.corpsName
      params.beginTime = this.submitDate && this.submitDate.length > 0 ? this.submitDate[0] : '';
      params.endTime = this.submitDate && this.submitDate.length > 0 ? this.submitDate[1] : '';
      if (!params.status && params.status !== 0) {
        delete params.status
      }
      getCaseListApi(params).then(res => {
        this.tableLoading = false;
        this.tableData = res.rows.rows;
        this.total = res.rows.total
        console.log(res.rows.rows, '工单列表');
      }).catch(() => {
        this.tableData = [];
        this.total = 0;
        this.tableLoading = false;
      })
    },

    //刷新
    handleRefresh () {
      this.conditionSearch()
    },

    //重置刷新
    handleReset () {
      this.submitDate = []
      this.filter = JSON.parse(JSON.stringify(this.defualtFilter))
      this.handleSearch(this.filter)
    },

    //打开详情页面
    goToDetailPage (data) {
      this.caseDetailMsg.row = data;
      this.caseDetailMsg.show = true;
      this.showContent = false
      this.caseDetailMsg.isRate = false;
      this.caseDetailMsg.type = 'rate';
      this.$store.commit('LOAD_CASE_PAGE', false)
    },

    //关闭详情页面
    caseDetailChildMsg (data) {
      if (data.isSave) {
        this.handleSearch(this.filter)
      }
      this.caseDetailMsg.show = data.close;
      this.showContent = true
    },

    //获取国家电话区号
    getContryCode () {
      getAreaCode().then(res => {
        this.$ls.set('AreaCode', res.rows)
      })
    },

    //获取产品线
    getproductList () {
      getProductApi({}).then(res => {
        this.productList = res.rows;
        this.$ls.set('product', res.rows)
      })
    },

    //获取时区
    getTimeZoneList () {
      getTimeZoneApi({}).then(res => {
        this.$ls.set('timeZone', res.rows)
      })
    },

    //打开创建工单页面
    showCreateCase () {
      this.$alert('<span>The current system is under maintenance. If you encounter any problems, please send an email to <span style="color:#3e84e9"> Tech.Support@Sangfor.com </span> to report the issue. </span>', 'Notice', {
          dangerouslyUseHTMLString: true
        });
      return;
      this.createCaseMsg.show = true;
      this.showContent = false
      this.$store.commit('LOAD_CASE_PAGE', false)
    },

    //关闭创建工单页面
    createCaseChildMsg (data) {
      if (data.isSave) {
        this.handleSearch(this.filter)
      }
      this.createCaseMsg.show = data.close;
      this.showContent = true
    },

    //跳转详情页
    handleRete (row) {
      this.caseDetailMsg.row = row;
      this.caseDetailMsg.show = true;
      this.caseDetailMsg.isRate = true;
      this.caseDetailMsg.type = 'rate';
      this.showContent = false
      this.$store.commit('LOAD_CASE_PAGE', false)
    }
  },
  watch: {
    '$store.getters.userInfo.corpsName': {
      handler (val) {
        if (val) {
          this.handleSearch(this.filter)
        }
      },
      immediate: true
    }
  },
  computed: {
    prodectDic () {
      let dicObj = {};
      for (var i in this.productList) {
        let key = Object.values(this.productList[i])[0]
        dicObj[key] = Object.values(this.productList[i])[2]
      }
      return dicObj
    },

    moment () {
      return moment
    }
  },

  created () {
    this.defualtFilter = JSON.parse(JSON.stringify(this.filter))
    // this.handleSearch(this.filter)
    this.getContryCode()
    this.getproductList()
    this.getTimeZoneList()
  },
  mounted () {
    this.$refs.myTable.$el.children[1].style.width = 'calc( 100% - 10px)';
  }

}
</script>

<style scoped lang="scss">
.sp_allCase {
  width: 100%;
  height: 100%;
  // overflow: auto;
  background-color: #ffffff;
  position: relative;
  .content {
    height: 100%;
    .sp_content {
      width: 100%;
      height: calc(100% - 56px);
      padding: 0 18px, 16px, 18px;
      .sp_search {
        width: calc(100% - 32px);
        display: flex;
        justify-content: space-between;
        background-color: #ffffff;
        margin: 16px 16px 7px 16px;
        .button_reset {
          // width: 38px;
          // padding: 9px 12px;
          // display: flex;
          // align-items: center;
          // .svg-icon {
          //   width: 12px;
          //   height: 12px;
          // }
          padding: 0;
          width: 38px;
          height: 32px;
        }
      }
      .case-table-content {
        height: calc(100% - 39px);
        .case-table {
          height: calc(100% - 48px);
          .oneLine {
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
          .table {
            height: 100%;
            /deep/.el-table__body-wrapper {
              height: calc(100% - 41px);
              overflow-y: auto !important;
              overflow-x: auto;
            }
            /deep/.el-table__fixed-right .el-table__fixed-body-wrapper,
            .el-table__fixed-right .el-table__fixed-footer-wrapper,
            .el-table__fixed-right .el-table__fixed-header-wrapper {
              // overflow-y: auto !important;
              height: calc(100% - 41px) !important;
              // pointer-events: none !important;
            }
          }
        }
        .pagination {
          margin-right: 0 !important;
          .el-pagination {
            height: 48px;
            margin-right: 0px !important;
            padding-right: 0px !important;
            display: flex;
            align-items: center;
            justify-content: flex-end;
            /deep/.el-pagination__editor {
              margin-left: 10px !important;
              padding: 0 !important;
            }
            /deep/.el-pager li.disabled {
              color: #ffffff !important;
            }
          }
        }
      }
    }
  }
}
::v-deep .el-table th.el-table__cell > .cell {
  // word-break: break-word;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>